import React from 'react';

import Title from './Title';
import Subtitle from './Subtitle';
import HeadingOne from './HeadingOne';
import HeadingTwo from './HeadingTwo';
import HeadingThree from './HeadingThree';
import Description from './Description';
import Buttons from './Buttons';

export default function BlockContent({ content }) {
  const {
    title,
    subtitle,
    headingOne,
    headingTwo,
    headingThree,
    description,
    isDescriptionSmall,
    buttons
  } = content || {};
  return (
    <>
      {content && (
        <div className="block-content">
          <Title content={title} />
          <Subtitle content={subtitle} />
          <HeadingOne content={headingOne} />
          <HeadingTwo content={headingTwo} />
          <HeadingThree content={headingThree} />
          <Description isSmall={isDescriptionSmall} content={description} />
          <Buttons buttons={buttons} identifier={title ? 'header' : ''} />
        </div>
      )}
    </>
  );
}
